// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Lui_extension from "lui/lui_extension.js";
import * as Lui_protocol from "lui/lui_protocol.js";
import * as Lui_ui from "lui/lui_ui.js";
import * as Mapre_web__Web_attachment_files from "./web_attachment_files.js";
import * as Mapre_web__Web_attachments_model from "./web_attachments_model.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__Fun from "melange/fun.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

const identifier = "mapre-chat-attachments";

function error(emit, message) {
  return Curry._2(emit, "failed", Curry._2(Lui_protocol.String_map.singleton, "message", {
    TAG: /* StringValue */ 0,
    _0: message
  }));
}

function selection_json(file) {
  return Js__Js_dict.fromList({
    hd: [
      "key",
      Mapre_wire__Json.str(file.key)
    ],
    tl: {
      hd: [
        "name",
        Mapre_wire__Json.str(file.name)
      ],
      tl: {
        hd: [
          "media_type",
          Mapre_wire__Json.str(file.media_type)
        ],
        tl: {
          hd: [
            "size",
            file.size
          ],
          tl: {
            hd: [
              "preview",
              Stdlib__Option.fold(null, Mapre_wire__Json.str, file.preview)
            ],
            tl: /* [] */ 0
          }
        }
      }
    }
  });
}

function selected(state, emit, files) {
  if (!state.enabled) {
    return;
  }
  const files$1 = Stdlib__List.filter_map((function (index) {
    return Caml_option.nullable_to_opt(files.item(index));
  }), Stdlib__List.init(files.length, Stdlib__Fun.id));
  const total = Stdlib__List.fold_left((function (n, file) {
    return n + file.size | 0;
  }), 0, state.owned) + Stdlib__List.fold_left((function (n, file) {
    return n + file.size | 0;
  }), 0, files$1) | 0;
  if ((Stdlib__List.length(state.owned) + Stdlib__List.length(files$1) | 0) > 8) {
    return error(emit, "Choose at most 8 attachments per message.");
  }
  if (Stdlib__List.exists((function (file) {
      if (file.size < 1) {
        return true;
      } else {
        return file.size > 10485760;
      }
    }), files$1)) {
    return error(emit, "Each attachment must be between 1 byte and 10 MiB.");
  }
  if (total > 26214400) {
    return error(emit, "Attachments must total at most 25 MiB per message.");
  }
  if (!Caml_obj.caml_notequal(files$1, /* [] */ 0)) {
    return;
  }
  const added = Stdlib__List.map(Mapre_web__Web_attachment_files.retain, files$1);
  state.owned = Stdlib.$at(state.owned, added);
  Curry._2(emit, "picked", Curry._2(Lui_protocol.String_map.singleton, "files", {
    TAG: /* StringValue */ 0,
    _0: JSON.stringify(Stdlib__Array.of_list(Stdlib__List.map(selection_json, added)))
  }));
}

function add_listener(state, element, name, callback) {
  element.addEventListener(name, callback);
  state.listeners = {
    hd: [
      element,
      name,
      callback
    ],
    tl: state.listeners
  };
}

function transfer(state, emit, get, $$event) {
  Stdlib__Option.iter((function (data) {
    const files = data.files;
    if (files.length > 0) {
      $$event.preventDefault();
      return selected(state, emit, files);
    }
    
  }), Caml_option.nullable_to_opt(Curry._1(get, $$event)));
}

function create(_node, $$document, emit) {
  const element = $$document.createElement("div");
  const input = $$document.createElement("input");
  element.className = "attachment-input";
  input.setAttribute("type", "file");
  input.setAttribute("multiple", "");
  input.setAttribute("aria-label", "Attach files");
  input.className = "attachment-file-input";
  element.appendChild(input);
  const state = {
    input,
    enabled: true,
    request: 0,
    owned: /* [] */ 0,
    listeners: /* [] */ 0
  };
  element.__mapreAttachments = state;
  add_listener(state, input, "change", (function (param) {
    Stdlib__Option.iter((function (param) {
      return selected(state, emit, param);
    }), Caml_option.nullable_to_opt(input.files));
    input.value = "";
  }));
  add_listener(state, element, "paste", (function (param) {
    return transfer(state, emit, (function (prim) {
      return prim.clipboardData;
    }), param);
  }));
  add_listener(state, element, "drop", (function (param) {
    return transfer(state, emit, (function (prim) {
      return prim.dataTransfer;
    }), param);
  }));
  add_listener(state, element, "dragover", (function ($$event) {
    if (Caml_option.nullable_to_opt($$event.dataTransfer) !== undefined) {
      $$event.preventDefault();
      return;
    }
    
  }));
  return element;
}

function set_property(element, name, property) {
  const state = element.__mapreAttachments;
  switch (name) {
    case "disabled" :
      if (property.TAG !== /* BoolValue */ 1) {
        return Stdlib.invalid_arg("invalid_attachment_input_property");
      }
      const value = property._0;
      state.enabled = !value;
      state.input.disabled = value;
      return;
    case "request" :
      if (property.TAG !== /* IntValue */ 2) {
        return Stdlib.invalid_arg("invalid_attachment_input_property");
      }
      const value$1 = property._0;
      if (value$1 >= 0) {
        state.input.hidden = true;
        if (value$1 !== state.request) {
          state.request = value$1;
          if (state.enabled) {
            state.input.click();
            return;
          } else {
            return;
          }
        } else {
          return;
        }
      } else {
        return Stdlib.invalid_arg("invalid_attachment_input_property");
      }
    case "retained" :
      if (property.TAG === /* StringValue */ 0) {
        let value$2 = property._0;
        const ids = Js__Js_json.decodeArray(JSON.parse(value$2));
        const ids$1 = ids !== undefined ? Stdlib__Array.to_list(Stdlib__Array.map((function (id) {
            const id$1 = Js__Js_json.decodeString(id);
            if (id$1 !== undefined) {
              return id$1;
            } else {
              return Stdlib.invalid_arg("invalid_attachment_key");
            }
          }), ids)) : Stdlib.invalid_arg("invalid_attachment_keys");
        state.owned = Stdlib__List.filter((function (file) {
          if (Stdlib__List.mem(file.key, ids$1)) {
            return true;
          } else {
            Mapre_web__Web_attachment_files.release(file.key);
            return false;
          }
        }), state.owned);
        return;
      } else {
        return Stdlib.invalid_arg("invalid_attachment_input_property");
      }
    default:
      return Stdlib.invalid_arg("invalid_attachment_input_property");
  }
}

function cleanup(element) {
  const state = element.__mapreAttachments;
  state.enabled = false;
  Stdlib__List.iter((function (param) {
    param[0].removeEventListener(param[1], param[2]);
  }), state.listeners);
  Stdlib__List.iter((function (file) {
    Mapre_web__Web_attachment_files.release(file.key);
  }), state.owned);
  state.owned = /* [] */ 0;
  state.listeners = /* [] */ 0;
}

function component(param) {
  return Lui_extension.component(identifier, {
    hd: {
      profile_os: /* WebOS */ 1,
      profile_host: /* WebHost */ 1
    },
    tl: /* [] */ 0
  }, true, /* [] */ 0, {
    hd: Lui_extension.property("disabled", /* BoolScalar */ 1, false, {
      TAG: /* BoolValue */ 1,
      _0: false
    }),
    tl: {
      hd: Lui_extension.property("retained", /* StringScalar */ 0, false, {
        TAG: /* StringValue */ 0,
        _0: "[]"
      }),
      tl: {
        hd: Lui_extension.property("request", /* IntScalar */ 2, false, undefined),
        tl: /* [] */ 0
      }
    }
  }, {
    hd: Lui_extension.$$event("picked", {
      hd: Lui_extension.event_field("files", /* StringScalar */ 0, true),
      tl: /* [] */ 0
    }),
    tl: {
      hd: Lui_extension.$$event("failed", {
        hd: Lui_extension.event_field("message", /* StringScalar */ 0, true),
        tl: /* [] */ 0
      }),
      tl: /* [] */ 0
    }
  });
}

function adapter_web_extension_remove_property(element, name) {
  if (name !== "request") {
    return set_property(element, name, name === "disabled" ? ({
        TAG: /* BoolValue */ 1,
        _0: false
      }) : ({
        TAG: /* StringValue */ 0,
        _0: "[]"
      }));
  }
  const state = element.__mapreAttachments;
  state.request = 0;
  state.input.hidden = false;
}

const adapter = {
  web_extension_create: create,
  web_extension_set_property: set_property,
  web_extension_remove_property: adapter_web_extension_remove_property,
  web_extension_cleanup: cleanup
};

function view(request, disabled, retained, on_select, on_error, children, context, parent) {
  const node = Lui_ui.extension(context, identifier);
  Stdlib__Option.iter((function (request) {
    Lui_ui.extension_property_signal(context, node, "request", Signal.map((function (value) {
      return {
        TAG: /* IntValue */ 2,
        _0: value
      };
    }), request));
  }), request);
  Lui_ui.extension_property_signal(context, node, "disabled", Signal.map((function (value) {
    return {
      TAG: /* BoolValue */ 1,
      _0: value
    };
  }), disabled));
  Lui_ui.extension_property_signal(context, node, "retained", Signal.map((function (ids) {
    return {
      TAG: /* StringValue */ 0,
      _0: JSON.stringify(Stdlib__Array.of_list(Stdlib__List.map(Mapre_wire__Json.str, ids)))
    };
  }), retained));
  Lui_ui.on_event(context, node, (function (param) {
    if (param.TAG !== /* ExtensionEvent */ 22) {
      return;
    }
    const id = param._1;
    switch (param._2) {
      case "failed" :
        if (id !== identifier) {
          return;
        }
        const match = Curry._2(Lui_protocol.String_map.find_opt, "message", param._3);
        if (match !== undefined && match.TAG === /* StringValue */ 0) {
          return Curry._1(on_error, match._0);
        } else {
          return Curry._1(on_error, "File selection failed.");
        }
      case "picked" :
        if (id !== identifier) {
          return;
        }
        const match$1 = Curry._2(Lui_protocol.String_map.find_opt, "files", param._3);
        if (match$1 !== undefined && match$1.TAG === /* StringValue */ 0) {
          return Curry._1(on_select, Mapre_web__Web_attachments_model.decode_selections(match$1._0));
        } else {
          return Curry._1(on_error, "Invalid file selection.");
        }
      default:
        return;
    }
  }));
  Stdlib__List.iter((function (child) {
    Curry._2(child, context, node);
  }), children);
  Stdlib__Option.iter((function (parent) {
    Lui_ui.append(context, parent, node);
  }), parent);
  return node;
}

export {
  identifier,
  component,
  adapter,
  view,
}
/* Lui_extension Not a pure module */
